import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconSquareMinus = createReactComponent('outline', 'square-minus', 'SquareMinus', __iconNode);

export default IconSquareMinus;